<template>
    <div class="card shadow-sm">
        <div class="card-body">
            <textarea rows="29" class="form-control" v-model="notes"></textarea>
            <button class="btn btn-primary btn-block mt-3" @click="setPersonalNotes">
                {{ $t('actions.save') }}
            </button>
        </div>
    </div>
</template>

<script>
import LockerRoomRepository from "../../../../repositories/LockerRoom/LockerRoomRepository";

export default {
    name: "Notes",
    data: () => ({
        notes: null,
    }),
    mounted() {
        this.getPersonalNotes();
    },
    methods: {
        getPersonalNotes() {
            return LockerRoomRepository
                .getPersonalNotes()
                .then((res) => {
                    this.notes = res.data.notes;
                })
        },
        setPersonalNotes() {
            return LockerRoomRepository
                .setPersonalNotes(this.notes)
                .then((res) => {
                    this.$snotify.success(this.$t('actions.updated'));
                });
        },
    }
}
</script>

<style scoped>

</style>
